import React from 'react';
import Icon from './Icon';
import {IconProps} from './IconProps';

export default function IconTransfer({className, height, title}: IconProps) {
  return (
    <Icon className={className} height={height} title={title}>
      M6.0481 5.91414L2.76777 9.19447H16.4571C16.4588 9.19447 16.4605 9.19448 16.4622 9.19449H17.1893L13.909
      5.91416C13.7137 5.7189 13.7137 5.40232 13.909 5.20706L14.2626 4.8535C14.4578 4.65824 14.7744 4.65824 14.9697
      4.8535L19.8839 9.76772C19.9815 9.86535 19.9815 10.0236 19.8839 10.1213L14.9697 15.0355C14.7744 15.2307 14.4578
      15.2307 14.2626 15.0355L13.909 14.6819C13.7137 14.4867 13.7137 14.1701 13.909 13.9748L17.1893
      10.6945H3.49999C3.4983 10.6945 3.4966 10.6945 3.49491 10.6945H2.76777L6.0481 13.9748C6.24336 14.1701 6.24336
      14.4866 6.0481 14.6819L5.69454 15.0355C5.49928 15.2307 5.1827 15.2307 4.98744 15.0355L0.0732233 10.1212C-0.0244078
      10.0236 -0.0244078 9.86532 0.0732233 9.76769L4.98744 4.85348C5.1827 4.65822 5.49928 4.65822 5.69454 4.85348L6.0481
      5.20703C6.24336 5.40229 6.24336 5.71888 6.0481 5.91414Z</Icon>
  );
}
